var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "database-server-svgrepo-com-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m465.7 114.3v19.2c9.5 3.4 16.4 12.4 16.4 23.1v66.7c0 10.6-6.9 19.7-16.4 23.1v19.2c9.5 3.4 16.4 12.4 16.4 23.1v66.7c0 10.6-6.9 19.7-16.4 23.1v19.2c9.5 3.3 16.4 12.4 16.4 23.1v66.7c0 13.5-11 24.5-24.6 24.5h-403c-13.6 0-24.6-11-24.6-24.5v-66.7c0-10.7 6.9-19.8 16.4-23.1v-19.2c-9.5-3.4-16.4-12.5-16.4-23.1v-66.7c0-10.7 6.9-19.8 16.4-23.1v-19.2c-9.5-3.4-16.4-12.5-16.4-23.1v-66.7c0-10.7 6.9-19.7 16.4-23.1v-19.2c-9.5-3.3-16.4-12.4-16.4-23.1v-66.7c0-13.5 11-24.5 24.6-24.5h403c13.6 0 24.6 11 24.6 24.5v66.7c0 10.7-6.9 19.8-16.4 23.1zm-419.4 373.4c0 4.4 3.6 8 8 8h403.4c4.4 0 8-3.6 8-8v-67.1c0-4.4-3.6-8-8-8h-403.4c-4.4 0-8 3.6-8 8zm16.3-91.4h386.8v-16.3h-386.8zm-16.3-40.8c0 4.5 3.6 8 8 8h403.4c4.4 0 8-3.5 8-8v-67c0-4.4-3.6-8-8-8h-403.4c-4.4 0-8 3.6-8 8zm419.4-199c0-4.5-3.6-8.1-8.2-8.1h-403c-4.6 0-8.2 3.6-8.2 8.1v66.7c0 4.5 3.6 8.2 8.2 8.2h337.7c4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.1-8.2 8.1h-329.6v16.4h386.8v-16.4h-24.5c-4.5 0-8.2-3.6-8.2-8.1 0-4.5 3.7-8.2 8.2-8.2h32.6c4.6 0 8.2-3.7 8.2-8.2zm-403.1-24.5h386.8v-16.3h-386.8zm-16.3-40.7c0 4.4 3.6 8 8 8h403.4c4.4 0 8-3.6 8-8v-67.1c0-4.4-3.6-8-8-8h-403.4c-4.4 0-8 3.6-8 8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m256 32.7h-136.2c-4.5 0-8.2 3.6-8.2 8.2 0 4.5 3.7 8.1 8.2 8.1h136.2c4.5 0 8.2-3.6 8.2-8.1 0-4.6-3.7-8.2-8.2-8.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m87.1 32.7h-16.3c-4.5 0-8.2 3.6-8.2 8.2 0 4.5 3.7 8.1 8.2 8.1h16.3c4.5 0 8.2-3.6 8.2-8.1 0-4.6-3.7-8.2-8.2-8.2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m256 164.8h-136.2c-4.5 0-8.2 3.6-8.2 8.1 0 4.5 3.7 8.2 8.2 8.2h136.2c4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.1-8.2-8.1z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m87.1 164.8h-16.3c-4.5 0-8.2 3.6-8.2 8.1 0 4.5 3.7 8.2 8.2 8.2h16.3c4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.1-8.2-8.1z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m256 296.9h-136.2c-4.5 0-8.2 3.6-8.2 8.1 0 4.5 3.7 8.2 8.2 8.2h136.2c4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.1-8.2-8.1z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m87.1 296.9h-16.3c-4.5 0-8.2 3.6-8.2 8.1 0 4.5 3.7 8.2 8.2 8.2h16.3c4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.1-8.2-8.1z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m256 429h-136.2c-4.5 0-8.2 3.6-8.2 8.1 0 4.5 3.7 8.2 8.2 8.2h136.2c4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.1-8.2-8.1z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m87.1 429h-16.3c-4.5 0-8.2 3.6-8.2 8.1 0 4.5 3.7 8.2 8.2 8.2h16.3c4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.1-8.2-8.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.1972edce0434f0b295d3847b41297607.svg";
export { ForwardRef as ReactComponent };